import { detectCloseElement } from "./helper";

export const product = {
	sidebar: function () {
		jQuery(".box-category-menu .title-category").on("click", function (e) {
			e.preventDefault();
			jQuery(this).toggleClass("active").next().slideToggle();
		});
		jQuery(".box-category-menu .content-category > ul > li > a").on("click", function (e) {
			e.preventDefault();
			jQuery(this).next().slideToggle();
			jQuery(this).toggleClass("active").parent().siblings().find("a").removeClass("active");
		});

		jQuery(".btn-filter").on("click", function () {
			jQuery(".box-category-menu").addClass("active");
		});
		jQuery(".box-category-menu .btn-close").on("click", function () {
			jQuery(".box-category-menu").removeClass("active");
		});
	},
	showMoreContent: function () {
		$(".section-product-detail.section-1 .tabslet-content").each(function () {
			const heightParent = $(this).find(".wrap-content-show-more .wrap").height();
			const heightChild = $(this).find(".wrap-content-show-more .wrap .format-content").height();
			if (heightChild > heightParent) {
				$(this).find(".btn-show-more-content").addClass("active");
			}
		});
		$("body").on("click", ".btn-show-more-content .btn-primary", function () {
			$(this).parent().removeClass('active').closest(".wrap-content-show-more").find(".wrap").css("max-height", "none");
		});
	},
	scrollShowPrice: function () {
		if (window.matchMedia("(min-width: 1023.98px)").matches) return;
		if ($(window).scrollTop() > 500) {
			$(".wrap-button-buy-sticky").addClass("active");
		} else {
			$(".wrap-button-buy-sticky").removeClass("active");
		}
	},
	init: function () {
		product.sidebar();
		product.showMoreContent();
	},
};

document.addEventListener(
	"scroll",
	function (e) {
		product.scrollShowPrice()
	},
	true
);
